import { Grid, TextField } from '@mui/material'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import {
  BooleanInput,
  Form,
  useNotify,
  useRecordContext,
  useRefresh,
  TextInput,
} from 'react-admin'
import {
  validateAutoSaveMultiInput,
  validateAutoSaveSingleInput,
} from '../../../../Utils/AutoSave'
import {
  blockInvalidCharFromNumberInput,
  numberInputOnWheelPreventChange,
} from '../../../../Utils/ConversionUtils'
import './style/index.scss'

const PaymentDetailsPanel = () => {
  const record = useRecordContext()
  const notify = useNotify()
  const refresh = useRefresh()
  const vehicleDetails = record.leadContact.vehicle
  const vehicleDocumentation = vehicleDetails.vehicleDocumentation
  const quotePaymentDetails = record.quotePaymentDetails

  const handleChequePaymentChange = async (e) => {
    const chequePaymentValue = e.target.checked

    const quotePaymentDetailsInputsToSave = [
      {
        name: 'quotePaymentDetails.acc',
        value: '00000000',
      },
      {
        name: 'quotePaymentDetails.sort',
        value: '000000',
      },
    ]

    const quoteRequestInputsToSave = [
      {
        name: 'deposit',
        value: chequePaymentValue ? false : true,
      },
      {
        name: 'depositAmount',
        value: `${chequePaymentValue ? '0' : '20'}`,
      },
    ]

    await Promise.all([
      validateAutoSaveSingleInput(record, e.target, notify, refresh),
      validateAutoSaveMultiInput(
        record,
        quotePaymentDetailsInputsToSave,
        notify,
        refresh,
        '',
        true
      ),
      validateAutoSaveMultiInput(
        record,
        quoteRequestInputsToSave,
        notify,
        refresh
      ),
    ]).then(() => {
      setTimeout(() => {
        refresh()
      }, 100)
    })
  }

  return (
    <Form>
      <Grid
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 4fr)',
          gridColumn: 1,
          gridRowStart: 1,
          gridRowEnd: 1,
        }}
      >
        <Grid
          style={{
            gridColumn: 1,
            gridRowStart: 1,
            gridRowEnd: 1,
          }}
        >
          <Typography className="collection-panel__title">
            Cheque payment
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography>No</Typography>
            <BooleanInput
              source="leadContact.vehicle.vehicleSalvage.chequePayment"
              label="Yes"
              style={{ alignItems: 'space-between' }}
              onChange={handleChequePaymentChange}
            />
          </Stack>
        </Grid>

        <Grid
          style={{
            gridColumn: '2 / span 12',
            gridRowStart: 1,
            gridRowEnd: 1,
          }}
        >
          <Grid
            style={{
              display: 'grid',
              gridColumn: 1,
              gridRowStart: 1,
              gridRowEnd: 1,
              marginBottom: '1rem',
            }}
          >
            Customer bank account details
          </Grid>
          <Grid
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 2fr)',
              gridColumn: '2 / span 7',
              gridRowStart: 2,
              gridRowEnd: 2,
              gap: 10,
            }}
          >
            <TextInput
              name="quotePaymentDetails.acc"
              label="Bank Account Number"
              source="quotePaymentDetails.acc"
              sx={{
                marginBottom: '-0.7rem !important',
                marginRight: '1.4rem !important',
              }}
              type={'number'}
              onWheel={numberInputOnWheelPreventChange}
              onKeyDown={blockInvalidCharFromNumberInput}
              onChange={(e) => {
                if (e.target.value.length > 8) {
                  e.target.value = e.target.value.slice(0, 8)
                }
              }}
              onBlur={async (e) => {
                // only update if changed from initial state
                if (quotePaymentDetails?.acc === e.target.value) return

                if (e.target.value.length > 0 && e.target.value.length < 8) {
                  notify('Bank account number must be 8 digits long', {
                    type: 'error',
                  })
                } else {
                  await validateAutoSaveMultiInput(
                    record,
                    [
                      {
                        name: 'quotePaymentDetails.acc',
                        value: e.target.value,
                      },
                    ],
                    notify,
                    refresh,
                    'Bank Account Number'
                  )
                }
              }}
            />
            <TextField
              name="quotePaymentDetails.sort"
              label="Sort Code"
              defaultValue={quotePaymentDetails?.sort}
              sx={{
                marginBottom: '-0.7rem !important',
              }}
              type={'number'}
              onWheel={numberInputOnWheelPreventChange}
              onKeyDown={blockInvalidCharFromNumberInput}
              onChange={(e) => {
                if (e.target.value.length > 6) {
                  e.target.value = e.target.value.slice(0, 6)
                }
              }}
              onBlur={async (e) => {
                // only update if changed from initial state
                if (quotePaymentDetails?.sort === e.target.value) return

                if (e.target.value.length > 0 && e.target.value.length < 6) {
                  notify('Sort code must be 6 digits long', {
                    type: 'error',
                  })
                } else {
                  await validateAutoSaveMultiInput(
                    record,
                    [
                      {
                        name: 'quotePaymentDetails.sort',
                        value: e.target.value,
                      },
                    ],
                    notify,
                    refresh,
                    'Sort Code'
                  )
                }
              }}
            />
          </Grid>
        </Grid>
        <Grid
          style={{
            display: 'grid',
            gridColumn: '2 / span 7',
            gridRowStart: 3,
            gridRowEnd: 3,
            marginBottom: '1rem',
            marginTop: '1rem',
          }}
        >
          Finance company details
        </Grid>
        <Grid
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 3fr)',
            gridColumn: '2 / span 7',
            gridRowStart: 4,
            gridRowEnd: 4,
            marginBottom: '1rem',
            gap: 10,
          }}
        >
          <TextField
            name="leadContact.vehicle.vehicleDocumentation.financeAccountNumber"
            label="Bank Account Number"
            defaultValue={vehicleDocumentation?.financeAccountNumber}
            sx={{ marginBottom: '-0.7rem !important' }}
            type={'number'}
            onWheel={numberInputOnWheelPreventChange}
            onKeyDown={blockInvalidCharFromNumberInput}
            onChange={(e) => {
              if (e.target.value.length > 8) {
                e.target.value = e.target.value.slice(0, 8)
              }
            }}
            onBlur={async (e) => {
              // only update if changed from initial state
              if (
                record.leadContact.vehicle.vehicleDocumentation
                  ?.financeAccountNumber === e.target.value
              )
                return

              if (e.target.value.length > 0 && e.target.value.length < 8) {
                notify('Bank account number must be 8 digits long', {
                  type: 'error',
                })
              } else {
                await validateAutoSaveSingleInput(
                  record,
                  e.target,
                  notify,
                  refresh,
                  'Account Number'
                )
              }
            }}
          />
          <TextField
            name="leadContact.vehicle.vehicleDocumentation.financeSortCode"
            label="Sort Code"
            defaultValue={vehicleDocumentation?.financeSortCode}
            sx={{ marginBottom: '-0.7rem !important' }}
            type={'number'}
            onWheel={numberInputOnWheelPreventChange}
            onKeyDown={blockInvalidCharFromNumberInput}
            onChange={(e) => {
              if (e.target.value.length > 6) {
                e.target.value = e.target.value.slice(0, 6)
              }
            }}
            onBlur={async (e) => {
              // only update if changed from initial state
              if (
                record.leadContact.vehicle.vehicleDocumentation
                  ?.financeSortCode === e.target.value
              )
                return

              if (e.target.value.length > 0 && e.target.value.length < 6) {
                notify('Sort code must be 6 digits long', {
                  type: 'error',
                })
              } else {
                await validateAutoSaveSingleInput(
                  record,
                  e.target,
                  notify,
                  refresh,
                  'Sort Code'
                )
              }
            }}
          />
          <TextField
            name="leadContact.vehicle.vehicleDocumentation.financeCompanyName"
            label="Name"
            defaultValue={
              vehicleDocumentation && vehicleDocumentation.financeCompanyName
            }
            sx={{ marginBottom: '-0.7rem !important' }}
            onBlur={async (e) =>
              await validateAutoSaveSingleInput(
                record,
                e.target,
                notify,
                refresh,
                'Name'
              )
            }
          />
        </Grid>
      </Grid>
    </Form>
  )
}

export default PaymentDetailsPanel
